import { NavLink } from "react-router";
import { BrandMark } from "@/components/layout/BrandMark";
import { site } from "@/lib/site";
import { cn } from "@/lib/utils";

export function SiteHeader() {
    return (
        <header className="flex items-center justify-between px-(--kt-gutter) py-6.5">
            <BrandMark />
            <nav
                aria-label="Primary"
                className="flex items-center gap-7.5 text-[13px] text-kt-ink/66"
            >
                <NavLink
                    to="/about"
                    className={({ isActive }) =>
                        cn("transition-colors hover:text-white", isActive && "text-white")
                    }
                >
                    About
                </NavLink>
                <a href={site.mailto} className="transition-colors hover:text-white">
                    Contact
                </a>
            </nav>
        </header>
    );
}
